import React from "react";
import styled from "@emotion/styled";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import Toast from "../../../ui/molecules/Toast.jsx";
import { setError, showNavigation } from "../store/uiSlice";
import HamburgerIcon from "../images/HamburgerIcon";
import NavigationBar from "./NavigationBar";

const Container = styled.div<{ navVisible: boolean }>`
  min-height: 100dvh;
  background: #1a1a1a;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: ${({ navVisible }) => (navVisible ? "100dvh" : "auto")};

  @media (min-width: 768px) {
    width: 75vw;
  }

  .details {
    color: #000;
  }
  .dropdown-options {
    border-radius: 8px;
    max-height: 252px;
  }
  .dropdown-option.empty {
    @media (min-width: 768px) {
      font-size: 16px;
    }
  }
`;

export const Header = styled.header`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  gap: 30px;
  align-items: center;
  padding: 40px 24px 8px 24px;
`;

export const MenuIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

export const Title = styled.div`
  font-family: "Rethink-Sans-Bold", "sans-serif";
  color: #fff;
  font-size: 18px;
  text-align: center;
  width: 252px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;

  @media (min-width: 768px) {
    width: 100%;
    font-size: 24px;
  }
`;

const Main = styled.div`
  flex: 1;
  padding: 24px;
`;

const Layout: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const error = useSelector((state: RootState) => state.ui.error);
  const errorToShow =
    error?.includes(
      "We encountered an unexpected error communicating with the restaurant",
    ) || error?.includes("Your specified ticket couldn't be found.")
      ? "This check does not exist."
      : error;
  const dispatch = useDispatch();
  const navVisible = useSelector(
    (state: RootState) => state.ui.navigationVisible,
  );

  return (
    <Container navVisible={navVisible}>
      {error && (
        <Toast
          show={!!error}
          setShow={() => {
            dispatch(setError(""));
          }}
          message={errorToShow}
        />
      )}
      <NavigationBar />
      <Header>
        <MenuIcon onClick={() => dispatch(showNavigation())}>
          <HamburgerIcon />
        </MenuIcon>
        <Title>inKind Manager</Title>
      </Header>
      <Main>{children}</Main>
    </Container>
  );
};

export default Layout;
